module.exports = __webpack_public_path__ + "static/super-admin-product-form-e4d9874924fe032ef0ae90489da9d29c.png";